<script>
import InputText from '@/components/InputText.vue';

/**
 * @description Поле ввода ИНН.
 * @type {Vue}
 */
export default {
  name: 'InputInn',
  props: {
    /**
     * @description Отключен.
     */
    disabled: {
      default: () => false,
      type: Boolean,
    },
    /**
     * @description Опциональный ввод.
     */
    optional: {
      default: () => false,
      required: false,
      type: Boolean,
    },
    /**
     * @description Заполнитель.
     */
    placeholder: {
      default: () => 'ИНН',
      required: false,
      type: String,
    },
    /**
     * @description Заголовок.
     */
    title: {
      default: () => 'ИНН',
      required: false,
      type: String,
    },
    /**
     * @description Значение.
     */
    value: {
      required: true,
      type: String,
    },
    /**
     * @description Тип раскладки виртуальной клавиатуры.
     * @type {string}
     */
    inputMode: { default: () => 'numeric', type: String },
    /**
     * @description Нарушения.
     */
    violations: {
      default: () => [],
      required: false,
      type: Array,
    },
  },
  render(createElement) {
    return createElement(InputText, {
      directives: [
        {
          name: 'mask',
          value: this.$options.innMask,
        },
      ],
      on: {
        input: (updatedValue) => this.$emit('input', updatedValue),
        invalid: (...args) => this.$emit('invalid', ...args),
      },
      props: {
        pattern: this.$options.innPattern,
        placeholder: this.placeholder,
        required: !this.optional,
        title: this.title,
        value: this.value,
        inputMode: this.inputMode,
        violations: this.violations,
        disabled: this.disabled,
      },
    });
  },
  innMask: '############',
  innPattern: '^\\d{12}$',
};
</script>
